/**
 * PaytableSlide.jsx — Single slide wrapper for the paytable carousel
 *
 * Handles the slide container div, the decorative glow (landscape/desktop),
 * and the active pointer-events class. Content is passed as children.
 */

const PaytableSlide = ({ isActive, isPortrait, glowSrc, children }) => (
  <div className={`spt-slide${isActive ? ' active' : ''}`}>
    {!isPortrait && (
      <img
        className="spt-slide-glow"
        src={glowSrc || ""}
        alt=""
        aria-hidden="true"
      />
    )}
    {children}
  </div>
);

export default PaytableSlide;
